import cn from 'classnames';

import CUSTOM_STYLES from '../../utils/modalStyle';
import GenericModal from '../GenericModal/GenericModal';

import styles from './TimeSlotModal.module.scss';

export default function TimeSlotModal({ isOpen, setIsOpen, title, options, selectedOption, onSelect }) {
  function onElementSelected(option) {
    onSelect(option);
    setIsOpen(false);
  }
  const modal = {
    isOpen,
    headerClass: styles.modalHeader,
    closeModal: setIsOpen,
    customStyles: {
      overlay: {
        ...CUSTOM_STYLES.overlay,
      },
      content: {
        width: '41.50rem',
      },
    },
    bodyOverwrite: 'fullBody',
    isFullscreen: true,
    navigation: [<h3 key={1}>{title}</h3>],
    view: 'Slots',
    body: {
      Slots: (
        <div className={styles.container}>
          {options &&
            options.map(option => (
              <button
                key={option.label}
                className={cn(styles.option, {
                  [styles.selectedOption]: selectedOption?.label === option.label,
                })}
                onClick={() => onElementSelected(option)}
                disabled={option.isDisabled === true}
              >
                {option.label}
              </button>
            ))}
        </div>
      ),
    },
  };

  return <GenericModal modal={modal} />;
}
